import React from "react";
import { Badge, withStyles } from "@material-ui/core";
import "./HighlightNewFeature.css"; // donde pondremos el CSS
import { isNil, isString } from "lodash";
import { parse } from "date-fns";
import { DATE_PATTERN } from "../../../../util/Constants";

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: 14,
    backgroundColor: theme.palette.semaphore.red,
    color: "#fff",
    fontWeight: "bold",
    fontSize: "0.8rem",
    borderRadius: "8px",
    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
    padding: 4,
  },
}))(Badge);

// Formato: (alias) const DATE_PATTERN: "yyyy-MM-dd"
export function resolveApplyEffects({ endDate }) {
  if (isNil(endDate) || !isString(endDate)) {
    return true;
  }

  try {
    // Now at 00
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    // End at 00
    const endDateParsed = parse(endDate, DATE_PATTERN, new Date());
    endDateParsed.setHours(0, 0, 0, 0);

    const result = now <= endDateParsed;

    return result;
  } catch (_) {
    return true;
  }
}

export const HighlightNewFeature = ({ children, endDate }) => {
  const applyEffects = resolveApplyEffects({ endDate });

  return (
    <StyledBadge
      badgeContent={applyEffects ? "Nuevo" : 0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      className={applyEffects ? "highlight-pulse" : ""}
      showZero={false}
    >
      <div className={applyEffects ? "highlight-pulse" : ""}>{children}</div>
    </StyledBadge>
  );
};
